import { apiRequest } from "."


export const submitReport = async (token, data)=>{
    try {
        const response = await apiRequest({
            method: 'POST',
            url: '/report',
            data: data,
            token: token,
            header: 'multipart/form-data',
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const getReports = async (token)=>{
    try {
        const response = await apiRequest({
            url: '/report/user',
            token: token,
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const getAllReports = async (token, month)=>{
    try {
        const response = await apiRequest({
            url: `/report/${month}`,
            token: token,
        })

        return response
    } catch (error) {
        console.log(error)
    }
}